import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export function hasMemberSession() {
  if (typeof window === "undefined") return false;
  const token = window.localStorage.getItem("memberToken");
  return Boolean(token && token !== "authenticated");
}

export default function MemberProtectedRoute({ children }) {
  const location = useLocation();

  if (!hasMemberSession()) {
    return (
      <Navigate
        to="/members/login"
        replace
        state={{ from: { pathname: location.pathname, search: location.search, hash: location.hash } }}
      />
    );
  }

  return children;
}